export default (value) => {
  let nCheck = 0;
  let nDigit = 0;
  let bEven = false;
  const cardNumber = value.replace(/\D/g, '');
  
  for (let n = cardNumber.length - 1; n >= 0; n--) {
    const cDigit = cardNumber.charAt(n);
    nDigit = parseInt(cDigit, 10);
    if (bEven && ((nDigit *= 2) > 9)) {
      nDigit -= 9;
    }
    nCheck += nDigit;
    bEven = !bEven;
  }
  
  if (nCheck > 0) return (nCheck % 10) === 0;
  // If digits were all zero
  return false;
};
